/*
* 判断类型
* */

const toString = Object.prototype.toString;
exports.isString = obj => {
    return toString.call(obj) === '[object String]';
};
exports.isObject = obj => {
    return toString.call(obj) === '[object Object]';
};
exports.isBoolean = obj => {
    return toString.call(obj) === '[object Boolean]';
};
exports.isNumber = obj => {
    return toString.call(obj) === '[object Number]';
};
exports.isFunction = obj => {
    return toString.call(obj) === '[object Function]';
};
exports.isArray = obj => {
    return toString.call(obj) === '[object Array]';
};

/*
* @arr 数据源
* @target 目标对象
* @key 匹配的对象属性
* */
exports.getArrayObjIndex = (arr, target, key) => {
    for(let i = 0, len = arr.length; i < len; i++) {
        if(arr[i][key] === target[key]) {
            return i;
        }
    }
};

exports.isUndefOrEmpty = (val) => {
    return val === '' || val === undefined || val === null
};

//保留两位小数的方法 四舍五入法
exports.keepTwodecimalFull = (num) =>{
    var result = parseFloat(num);
    if(isNaN(result)){
        return "";
    }
    result = Math.round(num * 100) / 100;
    var s_x = result.toString();
    var pos_decimal = s_x.indexOf('.');//小数点的所索引值

    //当整数时，pos_decimal = -1 自动补0
    if(pos_decimal < 0){
        pos_decimal = s_x.length;
        s_x += '.';
    }
     while (s_x.length <= pos_decimal + 2){
        s_x += '0';
     }
     return s_x;
}

//保留两位小数的方法 不四舍五入法
exports.keepTwodecimalFixed = (num) => {
    var result = parseFloat(num);
    if(isNaN(result)){
        return "";
    }

    return (parseInt(num*100)/100).toFixed(2);
}
exports.createalphabetList = (type = 'dict' ) =>{
    let alphabetList;
    type == 'dict' ?  alphabetList = {} :  alphabetList = []
    for(let i=0; i<=25; i++){
        const letter = String.fromCharCode(i+65);
        if (type == 'list') {
            alphabetList.push(letter)
        } else if(type == 'dict') {
            alphabetList[i] = letter
        }
    }
    return alphabetList
}

exports.getUrlParam = () => {
    let name, value;
    let str = location.href;
    let num = str.indexOf("?");
    str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]
    let arr = str.split("&"); //各个参数放到数组里
    let param = {};
    for (let i = 0; i < arr.length; i++) {
        num = arr[i].indexOf("=");
        if (num > 0) {
            name = arr[i].substring(0, num);
            value = arr[i].substr(num + 1);
            param[name] = value;
        }
    }
    return param
}

exports.throttle = (fn, wait) => {
    let timer;
    return function () {
        if (!timer) {
            timer = setTimeout(() => {
                timer = null;
                fn.apply(this, arguments);
            }, wait)
        }
    }
}

exports.debounce = (fn, wait) => {
    var timeout = null;
    return function() {
        if(timeout !== null)   clearTimeout(timeout);
        timeout = setTimeout(fn, wait);
    }
}

let getBrowserGMT = function () {
    var dates = new Date();
    return -dates.getTimezoneOffset() / 60;
};

exports.getFormatTime = function (d, ks) {
    d = d + ((ks - getBrowserGMT()) * 60 || 0) * 60000;
    var date = new Date(d), Y, M, D, h, m, s;
    if (!d) {
        return;
    }
    if (parseInt(d) < 86400) {
        return d;
    }
    d = d;
    Y = date.getFullYear() + '/';
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
    M = M < 10 ? "0" + M : M;
    D = (date.getDate() + ' ') < 10 ? "0" + (date.getDate() + ' ') : (date.getDate() + ' ');
    h = date.getHours();
    h = (h < 10 ? "0" + h : h) + ':';
    m = date.getMinutes();
    m = (m < 10 ? "0" + m : m) + ':';
    s = date.getSeconds();
    s = (s < 10 ? "0" + s : s);
    var dayTime = h+m+s;
    if(dayTime === '00:00:00'){
        return Y + M + D
    }
    return Y + M + D + h + m + s;
};

exports.getFormatTimeUS = function (d, ks) {
    d = d + ((ks - getBrowserGMT()) * 60 || 0) * 60000;
    var date = new Date(d), Y, M, D, h, m, s;
    if (!d) {
        return;
    }
    if (parseInt(d) < 86400) {
        return d;
    }
    d = d;
    Y = date.getFullYear() + " ";
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) ;
    M = M + '/';
    D = (date.getDate() + ' ') < 10 ? "0" + (date.getDate()) : (date.getDate());
    D = D + '/';
    h = date.getHours();
    h = (h < 10 ? "0" + h : h) + ':';
    m = date.getMinutes();
    m = (m < 10 ? "0" + m : m) + ':';
    s = date.getSeconds();
    s = (s < 10 ? "0" + s : s);
    var dayTime = h+m+s;
    if(dayTime === '00:00:00'){
        return M + D + Y
    }
    return M + D + Y  + h + m + s;
};

exports.randomString = (len=6) => {
    let str = 'abcdefghijklmnopqrstuvwxyz0123456789_/+=';
    let res = '';
    for(let i=0; i<len; i++) {
        let index = Math.floor(Math.random() * str.length);
        res += str.charAt(index);
    }

    return res;
}

exports.getENV = () => {
    return () => {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    }
};
exports.isAndroid = () => {
    let u = navigator.userAgent;
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
};

exports.isIOS = () => {
    let u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
};

exports.toQueryParams = (obj)=>{
    const params = new URLSearchParams();
    for (const key in obj) {
        const it = obj[key];
        if (Array.isArray(it)) {
            value.forEach(val => params.append(key, val));
        } else {
            params.append(key, it);
        }
            
    }
    return params.toString();
}




// WEBPACK FOOTER //
// ./src/utils/util.js